import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonAlignRight
  from 'components/atoms/Editors/EditorMenuButtonAlignRight/EditorMenuButtonAlignRight.styles';

const EditorMenuButtonAlignRight = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonAlignRight');

  return <StyledEditorMenuButtonAlignRight buttonRef={ref} {...innerProps} />
});

EditorMenuButtonAlignRight.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonAlignRight;
